// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 47) return "client-04f77f9e7631a334a266.css";
	// return url for filenames based on template
	return "" + chunkId + ".css";
};